import * as React from "react";
import { HideThisOutput } from "@utils";
import { Text } from '@amzn/dvui/dist/Text';
import { Link } from '@amzn/dvui/dist/Link';
import * as styles from './HideThisOverlay.module.scss'
import { FallbackForm } from '../../../../../../../../Explore/DVWebNodeHover/Hover/HideThis/components/FallbackForm';


interface HideThisOverlayProps {
    hideThisOutput?: HideThisOutput
    children: React.ReactChild | React.ReactChild[]
    onHideThisActionChange?: (out: HideThisOutput) => void
    hideThis: () => void
    hasTimer: boolean
}


export const HideThisOverlay: React.StatelessComponent<HideThisOverlayProps> = (props: HideThisOverlayProps) => {
    return props.hideThisOutput && props.onHideThisActionChange ? (
        <div className={styles.cardOverlay}>
            <div className={styles.cardOverlayContentWrapper}>
                {<div className={styles.body}>
                    <div className={styles.undoPageBody}>
                        <Text tag="h5">
                            {props.hideThisOutput.message}
                        </Text>
                        <div className={styles.undoPageOptions}>
                            {props.hideThisOutput.hideThisAction &&
                                <FallbackForm endpointUrl={props.hideThisOutput.hideThisAction.endpoint} onSuccess={[props.onHideThisActionChange]}>
                                    <Link>{props.hideThisOutput.hideThisAction.text}</Link>
                                </FallbackForm>}
                            {props.hideThisOutput.manageLink &&
                                <Link href={props.hideThisOutput.manageLink.href}>
                                    {props.hideThisOutput.manageLink.text}
                                </Link>}
                        </div>
                    </div>
                </div>
                }
            </div>
            <div className={styles.isolate}>
                {props.children}
            </div>
        </div>
    )
        :
        <>{props.children}</>
}